
const Button = ({button=true,title,className='btn btn-primary',onClick,icon:Icon}) => {

    if(button) {
        return (
            <button onClick={onClick} className={className}>{Icon} {title}</button>
        );
    }

    return (
        <a href="javascript:;" onClick={onClick} className={className}>{Icon} {title}</a>
    )
    
};

export default Button;